import { render, staticRenderFns } from "./action-docs-modal.vue?vue&type=template&id=5773b822&scoped=true"
import script from "./action-docs-modal.vue?vue&type=script&lang=js"
export * from "./action-docs-modal.vue?vue&type=script&lang=js"
import style0 from "./action-docs-modal.vue?vue&type=style&index=0&id=5773b822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773b822",
  null
  
)

export default component.exports